<template>
  <div class="card mb-4 account-completion" :class="{'d-none' : isHide}">
    <div class="card-body pt-1 pb-1">
      <h3 class="mb-0 pb-0 t-500 clearfix">
        <span class="pull-left d-block text" :class="{ 'mt-0': !isLoaded }">Enrich your profile</span>
        <circle-progress v-if="isLoaded" :diameter="50" :completedSteps="completedSteps" :totalSteps="totalSteps" :class="`pull-right`" />
      </h3>

      <hr class="hr-outlined mt-1" :class="{'mb-1': !isOpen}"/>

      <ul v-if="isLoaded && isOpen" class="list-unstyled mb-0">
        <!-- account created -->
        <li class="clearfix mb-2">
          <span class="rounded-circle bg-green-light bd-color-green-light bd-x bd-y d-block pull-left">
            <i class="fa fa-check t-white text-center d-block t-sm"></i>
          </span>
          <p class="mb-0 pull-left pl-3 rounded-circle-text">
            Account created
          </p>
        </li>

        <!-- upload profile picture -->
        <li class="clearfix mb-2 is-hover">
          <label for="newFile" class="width--100per mb-0 is-hover pull-left" @click="openResearcherPictureModal()">
            <span for="newFile" class="rounded-circle bd-x bd-y d-block pull-left" :class="{'bg-green-light bd-color-green-light': isProfilePicture}">
              <i class="fa text-center d-block t-xs" :class="{'fa-camera t-secondary': !isProfilePicture, 'fa-check t-white': isProfilePicture}"></i>
            </span>
            <p class="mb-0 pull-left pl-3 rounded-circle-text">
              Add picture to be recognized
            </p>
          </label>

          <!-- hidden input when user has no image -->
          <input v-if="!isProfilePicture"
            type="file"
            name="newFile"
            id="newFile"
            class="btn-input-file"
            accept="image/png, image/jpeg, image/gif, image/jpg"
            @change="$emit('uploadAvatar', $event)">
        </li>

        <!-- research interest -->
        <li class="clearfix mb-2 is-hover" @click.prevent="openResearcherResearchInterests()">
          <span class="rounded-circle bd-x bd-y d-block pull-left" :class="{'bg-white': !isResearchInterests, 'bg-green-light bd-color-green-light': isResearchInterests}">
            <i class="fa text-center d-block t-sm" :class="{'fa-star t-secondary': !isResearchInterests, 'fa-check t-white': isResearchInterests}"></i>
          </span>
          <p class="mb-0 pull-left pl-3 rounded-circle-text">
            Add your research interests
          </p>
        </li>

        <!-- social media -->
        <li class="clearfix mb-2" @click.prevent="openResearcherImport()" :class="{'is-hover': !user.orcid_id}">
          <span class="rounded-circle bd-x bd-y d-block pull-left" :class="{'bg-white': !isConnected, 'bg-green-light bd-color-green-light': isConnected}">
            <i class="fa text-center t-sm" :class="{'fa-download t-secondary': !isConnected, 'fa-check t-white': isConnected}"></i>
          </span>
          <p class="mb-0 pull-left pl-3 rounded-circle-text">
            Import profile data
          </p>
        </li>

        <!-- about me -->
        <li class="clearfix mb-2 is-hover" @click.prevent="openResearcherAbout()">
          <span class="rounded-circle bd-x bd-y d-block pull-left" :class="{'bg-white': !isBiography, 'bg-green-light bd-color-green-light': isBiography}">
            <i class="fa text-center t-sm" :class="{'fa-pencil t-secondary': !isBiography, 'fa-check t-white': isBiography}"></i>
          </span>
          <p class="mb-0 pull-left pl-3 rounded-circle-text">
            Introduce yourself
          </p>
        </li>

        <li class="clearfix mb-0 is-hover" @click.prevent="openResearcherExperiences()">
          <span class="rounded-circle bd-x bd-y d-block pull-left" :class="{'bg-white': !isExperiences, 'bg-green-light bd-color-green-light': isExperiences}">
            <i class="fa text-center d-block t-sm" :class="{'fa-briefcase t-secondary': !isExperiences, 'fa-check t-white': isExperiences}"></i>
          </span>
          <p class="mb-0 pull-left pl-3 rounded-circle-text">
            Add your experience
          </p>
        </li>
      </ul>

      <!-- render spinner if not loaded -->
      <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />

      <hr v-if="isOpen" class="hr-outlined mb-1" />
      <a v-if="isOpen" href="#" class="text-center t-regular d-block t-uppercase t-sm" @click.prevent="isOpen = false">
        Close
      </a>

      <a v-if="!isOpen" href="#" class="text-center t-regular d-block t-uppercase t-sm" @click.prevent="isOpen = true">
        View all
      </a>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/shared/Spinner'
import CircleProgress from '@/components/shared/CircleProgress'

export default {
  name: 'userAccountCompletion',
  components: {
    Spinner,
    CircleProgress
  },
  props: {
    isLoaded: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      required: true
    },
    researcher: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      totalSteps: 6,
      isOpen: true,
      isHide: false
    }
  },
  computed: {
    isProfilePicture () {
      return !this.isEmpty(this.user.avatar)
    },
    isConnected () {
      return !this.isEmpty(this.user.orcid_id)
    },
    isBiography () {
      return !this.isEmpty(this.researcher.about)
    },
    isResearchInterests () {
      return !this.isEmpty(this.researcher.research_interests)
    },
    isExperiences () {
      return !this.isEmpty(this.researcher.experiences)
    },
    completedSteps () {
      let c = 1
      if (this.isProfilePicture) c += 1
      if (this.isConnected) c += 1
      if (this.isBiography) c += 1
      if (this.isResearchInterests) c += 1
      if (this.isExperiences) c += 1
      return c
    }
  },
  methods: {
    openResearcherAbout () {
      this.$events.$emit('modal:researcher:edit:single:open', this.user, this.researcher, 'about')
    },
    openResearcherExperiences () {
      this.$events.$emit('modal:researcher:edit:single:open', this.user, this.researcher, 'experiences')
    },
    openResearcherImport () {
      if (!this.user.orcid_id) this.$events.$emit('modal:researcher:edit:single:open', this.user, this.researcher, 'social', 'small')
    },
    openResearcherResearchInterests () {
      this.$events.$emit('modal:researcher:edit:single:open', this.user, this.researcher, 'researchInterests')
    },
    openResearcherPictureModal () {
      if (this.user.avatar) this.$emit('openAvatar', `${process.env.VUE_APP_S3_URL}${this.user.avatar}`)
    }
  }
}
</script>
